export default __webpack_public_path__ + "static/8332-534407320ac74470b49c1ddf1e59e321.jpg";